import { render, staticRenderFns } from "./RegionMappingDetailView.vue?vue&type=template&id=5ae592ce&scoped=true"
import script from "./RegionMappingDetailView.vue?vue&type=script&lang=js"
export * from "./RegionMappingDetailView.vue?vue&type=script&lang=js"
import style0 from "./RegionMappingDetailView.vue?vue&type=style&index=0&id=5ae592ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae592ce",
  null
  
)

export default component.exports